/**
 * Next Match Countdown
 * Ticks every second. On expiry shows "Kick off!".
 * Hides the entire block 2 hours after kickoff.
 */
(function () {
  'use strict';

  var TWO_HOURS_MS = 2 * 60 * 60 * 1000;

  function pad(n) {
    return String(n).padStart(2, '0');
  }

  function initCountdown(el) {
    var kickoffISO = el.getAttribute('data-kickoff');
    if (!kickoffISO) return;

    var kickoffTime = new Date(kickoffISO).getTime();
    if (isNaN(kickoffTime)) return;

    var block     = el.closest('.block-next-match');
    var daysEl    = el.querySelector('[data-unit="days"]');
    var hoursEl   = el.querySelector('[data-unit="hours"]');
    var minutesEl = el.querySelector('[data-unit="minutes"]');
    var secondsEl = el.querySelector('[data-unit="seconds"]');

    function tick() {
      var now  = Date.now();
      var diff = kickoffTime - now;

      // Hide block 2 hours after kickoff
      if (diff < -TWO_HOURS_MS) {
        if (block) block.hidden = true;
        clearInterval(timer);
        return;
      }

      // Kickoff passed — show message
      if (diff <= 0) {
        el.innerHTML = '<span class="next-match__kickoff-msg">Kick off! ⚽</span>';
        clearInterval(timer);
        return;
      }

      var totalSeconds = Math.floor(diff / 1000);
      var days         = Math.floor(totalSeconds / 86400);
      var hours        = Math.floor((totalSeconds % 86400) / 3600);
      var minutes      = Math.floor((totalSeconds % 3600) / 60);
      var seconds      = totalSeconds % 60;

      if (daysEl)    daysEl.textContent    = pad(days);
      if (hoursEl)   hoursEl.textContent   = pad(hours);
      if (minutesEl) minutesEl.textContent = pad(minutes);
      if (secondsEl) secondsEl.textContent = pad(seconds);
    }

    tick();
    var timer = setInterval(tick, 1000);
  }

  function init() {
    document.querySelectorAll('.next-match__countdown[data-kickoff]').forEach(initCountdown);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
